import { useCallback } from "react";

import { usePlanEditMutation } from "../../../../../repository/existing/mutation/use-plan-edit-mutation";

import type { ProductPlanI18nFormModel } from "../../../../../type";

type Props = {
	viewModel: ProductPlanI18nFormModel["ViewModel"];
	onResetViewModel: () => void;
};

export const useUpdatePlanI18n = ({ viewModel, onResetViewModel }: Props) => {
	const { onUpdatePlan: _onUpdatePlan } = usePlanEditMutation({ onResetViewModel });

	const onUpdatePlan = useCallback(() => {
		_onUpdatePlan({ ...viewModel });
	}, [_onUpdatePlan, viewModel]);

	return {
		onUpdatePlan,
	};
};
